module.exports = __webpack_public_path__ + "static/media/recovery-color.682061cc.png";